var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalSupplyDP = function SvgDAhuSignalSupplyDP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "680 272 680 56 341 56 341 54 682 54 682 271.98 680 272",
    fill: "#1c9d5b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "636 282.99 634 282.99 634 269.99 650 269.99 650 271.99 636 271.99 636 282.99",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 269.99,
    width: 4,
    height: 2,
    fill: "#1c9d5b"
  }))));
};
export default SvgDAhuSignalSupplyDP;